(() => {
  let lastInteractionScrollY = window.scrollY || 0;

  const lockPage = () => {
    if (!document.body.dataset.stynncoDrawerScrollY) {
      document.body.dataset.stynncoDrawerScrollY = String(lastInteractionScrollY || window.scrollY || 0);
    }

    const scrollY = Number(document.body.dataset.stynncoDrawerScrollY || 0);

    document.documentElement.classList.add('stynnco-drawer-lock');
    document.body.classList.add('stynnco-drawer-lock', 'overflow-hidden-tablet');

    if (Math.abs(window.scrollY - scrollY) > 1) {
      window.scrollTo(0, scrollY);
      window.requestAnimationFrame(() => window.scrollTo(0, scrollY));
    }
  };

  const unlockPage = () => {
    const scrollY = Number(document.body.dataset.stynncoDrawerScrollY || 0);

    document.documentElement.classList.remove('stynnco-drawer-lock');
    document.body.classList.remove(
      'stynnco-drawer-lock',
      'overflow-hidden-tablet',
      'overflow-hidden-mobile',
      'overflow-hidden-desktop'
    );
    delete document.body.dataset.stynncoDrawerScrollY;

    if (scrollY > 0 && Math.abs(window.scrollY - scrollY) > 1) {
      window.scrollTo(0, scrollY);
    }
  };

  const syncDrawerState = () => {
    const details = document.querySelector('header-drawer details[open]');
    if (details && !details.classList.contains('drawer-closing')) {
      lockPage();
    } else {
      unlockPage();
    }
  };

  const observeDrawers = () => {
    document.querySelectorAll('header-drawer details').forEach((details) => {
      if (details.dataset.stynncoDrawerObserved === 'true') return;

      details.dataset.stynncoDrawerObserved = 'true';
      new MutationObserver(syncDrawerState).observe(details, {
        attributes: true,
        attributeFilter: ['open', 'class'],
      });
    });
  };

  const rememberScrollBeforeOpen = (event) => {
    lastInteractionScrollY = window.scrollY || 0;

    const summary = event.target.closest?.('header-drawer summary');
    const details = summary?.closest('details');
    if (!summary || !details || details.hasAttribute('open')) return;

    document.body.dataset.stynncoDrawerScrollY = String(lastInteractionScrollY);
  };

  document.addEventListener('pointerdown', rememberScrollBeforeOpen, true);
  document.addEventListener('touchstart', rememberScrollBeforeOpen, { capture: true, passive: true });
  document.addEventListener('mousedown', rememberScrollBeforeOpen, true);
  document.addEventListener('click', syncDrawerState, true);
  document.addEventListener('DOMContentLoaded', () => {
    observeDrawers();
    syncDrawerState();
  });
  observeDrawers();
  syncDrawerState();
})();
